import React, { useState, useEffect } from "react";
import { adjustCardQuantityToCart } from "@actions/buyOrders";
import styled from "@emotion/styled";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

const StepperContainer = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #ff9c1b;
  text-align: center;
  display: flex;
  align-items: center;

  @media (max-width: 465px) {
    font-size: 14px;
  }
  @media (max-width: 420px) {
    font-size: 12px;
  }
`;

const MinusSpan = styled.span`
  cursor: pointer;
  font-size: 11px !important;
  height: 100%;
  visibility: ${props => props.setVisibility};
`;

const QuantitySpan = styled.span`
  font-weight: normal;
  color: #1f2021;
  width: 25px;
  height: 100%;
  display: inline-block;
  margin-right: 4px;
  margin-left: 4px;
  @media (max-width: 465px) {
    margin-right: 0px;
    margin-left: 0px;
  }
`;

const PlusSpan = styled.span`
  cursor: pointer;
  height: 100%;
  color: ${props => props.color};
  font-size: 11px !important;
  visibility: ${props => props.setVisibility};
`;

const CardAdditionComponent = ({
  card,
  clearTheMessage,
  confirmDelete,
  clearConfirmModal,
  cartError,
  cartOpenConfirmModal,
  cartLoading,
  loadingAction,
  updateCartError
}) => {
  const dispatch = useDispatch();
  const cartId = useSelector(state => state.cartBuy.cartId);
  const [plusColor, changePlusColor] = useState(
    cartError && cartError.cardId === card.id ? "#777984" : "inherit"
  );
  useEffect(() => {
    changePlusColor(
      cartError && cartError.cardId === card.id ? "#777984" : "inherit"
    );
  }, [cartError]);

  const checkAndClearConfirm = () => {
    if (cartOpenConfirmModal.status) {
      clearConfirmModal();
    }
  };

  const addCard = () => {
    if (!cartLoading.status) {
      checkAndClearConfirm();
      if (cartError && cartError.cardId === card.id) {
        return;
      } else {
        clearTheMessage();
        dispatch(
          adjustCardQuantityToCart(
            cartId,
            card.id,
            1,
            loadingAction,
            updateCartError
          )
        );
      }
    }
  };

  const minusCard = () => {
    if (!cartLoading.status) {
      checkAndClearConfirm();
      clearTheMessage();
      if (card.quantity > 1) {
        dispatch(
          adjustCardQuantityToCart(
            cartId,
            card.id,
            -1,
            loadingAction,
            updateCartError
          )
        );
      } else {
        confirmDelete({
          status: true,
          cartId: cartId,
          cardId: card.id
        });
      }
    }
  };
  return (
    <StepperContainer>
      <MinusSpan setVisibility={card.type === "newEcode" ? "hidden" : ""}>
        <FaMinus
          onClick={() => card.type !== "newEcode" && minusCard()}
          style={{ fontSize: "inherit" }}
        />
      </MinusSpan>
      <QuantitySpan>{card.quantity}</QuantitySpan>
      <PlusSpan
        color={plusColor}
        setVisibility={card.type === "newEcode" ? "hidden" : ""}
      >
        <FaPlus
          onClick={() => card.type !== "newEcode" && addCard()}
          style={{ fontSize: "inherit" }}
        />
      </PlusSpan>
    </StepperContainer>
  );
};
export default CardAdditionComponent;
